import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  fetchTeamSuccess,
  fetchTeamFailure,
  saveTeamSuccess,
  saveTeamFailure,
  updateTeamSuccess,
  updateTeamFailure,
  deleteTeamSuccess,
  deleteTeamFailure,
} from "./actions";
import { fetchTeam, saveTeam, updateTeam, deleteTeam } from "./team";

// 🔹 Fetch Team Members
function* fetchTeamSaga(action) {
  try {
    const { _id } = action.payload || {};
    const data = yield call(fetchTeam, _id);

    yield put(fetchTeamSuccess(data?.data || []));
    if (action.callback) action.callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(fetchTeamFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Save Team Member
function* saveTeamSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};
    const response = yield call(saveTeam, apiPayloadRequest);

    if (response?.type === 1) {
      // Preserve all fields from response
      const fullResponse = {
        type: response.type,
        message: response.message,
        data: response.data || {},
        memberObjId: response.memberObjId, // ✅ carry this forward
      };

      yield put(saveTeamSuccess(fullResponse.data || {}));

      if (callback) callback(fullResponse);
    } else {
      yield put(saveTeamFailure(response.error || "Failed to save team member."));
      if (callback) callback({ type: 0, error: response.error });
    }
  } catch (error) {
    yield put(saveTeamFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}




// 🔹 Update Team Member
function* updateTeamSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};
    const data = yield call(updateTeam, apiPayloadRequest);

    yield put(updateTeamSuccess(data?.data || apiPayloadRequest));

    if (callback) callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(updateTeamFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}


// 🔹 Delete Team Member
function* deleteTeamSaga(action) {
  try {
    const { _id, memberObjId, callback } = action.payload;
    const data = yield call(deleteTeam, { _id, memberObjId });

    if (data?.type === 1) {
      yield put(deleteTeamSuccess({ memberObjId }));
      if (callback) callback({ type: 1, data });
    } else {
      yield put(deleteTeamFailure(data?.message || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.message });
    }
  } catch (error) {
    yield put(deleteTeamFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

export default function* teamWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_TEAM_REQUEST, fetchTeamSaga);
  yield takeLatest(actionTypes.SAVE_TEAM_REQUEST, saveTeamSaga);
  yield takeLatest(actionTypes.UPDATE_TEAM_REQUEST, updateTeamSaga);
  yield takeLatest(actionTypes.DELETE_TEAM_REQUEST, deleteTeamSaga);
}
